class YoutubeEmbed extends HTMLElement {
  constructor() {
    super();
  }

  injectYouTubePlayer() {
    // Move the injectYouTubePlayer function to be a class method
    var videoId =
      this.querySelector('#youtube-player').getAttribute('youtube-url');
    var iframe = document.createElement('iframe');
    iframe.className = 'top-0 absolute left-0 w-full h-full border-0 z-50';
    iframe.setAttribute('src', videoId);
    iframe.id = 'youtube-iframe';
    iframe.setAttribute('title', 'YouTube video player');
    iframe.setAttribute('allow', 'autoplay');

    var container = this.querySelector('#youtube-player');
    container.appendChild(iframe);
  }

  connectedCallback() {
    if (this.querySelector('.play-button')) {
      this.querySelector('.play-button').addEventListener('click', () => {
        if (window.Shopify && window.Shopify.analytics) {
          window.Shopify.analytics.publish('youtube_play', {
            youtube_play: true,
            page_url: window.location.href,
            page_path: window.location.pathname,
            page_title: document.title,
            youtube_url:
              this.querySelector('#youtube-player')?.getAttribute(
                'youtube-url'
              ) || 'unknown',
          });
        }

        if (this.querySelector('.youtube-modal')) {
          this.querySelector('.youtube-modal').classList.remove('hidden');
        } else {
          this.querySelectorAll('.youtube-cover').forEach((el) => {
            el.style.setProperty('display', 'none', 'important');
          });
          this.querySelector('.youtube-container').classList.remove('hidden');
          this.querySelector('.play-button').classList.add('hidden');
        }
        this.injectYouTubePlayer();
      });
    }

    if (this.querySelector('.youtube-modal')) {
      this.querySelector('.youtube-modal').addEventListener('click', (e) => {
        if (!e.target.classList.contains('video-container')) {
          if (this.querySelector('.youtube-modal')) {
            this.querySelector('.youtube-modal').classList.add('hidden');
          }
          this.querySelector('iframe').remove();
        }
      });
    }

    document.addEventListener('playVideo', function (e) {
      console.log('playVideo event received');
      this.injectYouTubePlayer();
    });
  }
}
customElements.define('youtube-embed', YoutubeEmbed);
